import { render } from "./BarProgress3.vue?vue&type=template&id=cc87a7c2"
import script from "./BarProgress3.vue?vue&type=script&lang=js"
export * from "./BarProgress3.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__